'use strict';

module.exports = {
    OK: 'OK',
    PENDING: 'PENDING',
    ERROR: 'ERROR'
};